export async function waitSleep(millionSecond) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve();
    }, millionSecond);
  });
}
